module.exports = __webpack_public_path__ + "officialStatic/img/wirelessBg.9b85788.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/wirelessBg.jpg
// module id = ARGg
// module chunks = 0